import { useState } from "react";
import { X } from "lucide-react";
import ImageDialog from "../../UI/viewDialogs/ImageDialog";

const SelectedImagesBox = ({
  errors,
  selectedImages,
  setValue,
  name,
  remove,
}) => {
  const [clickedImage, setClickedImage] = useState(null);
  const isSelectedImage = selectedImages
    ? selectedImages.length !== 0
      ? true
      : false
    : false;

  const handleOpen = (picture) => {
    setClickedImage(picture);
  };

  const removeSelectedImage = (selectedInd) => {
    setValue(name, "");
    remove(selectedInd);
  };
  return (
    <>
      <div className={`selectedImgContainer ${errors ? "border-red-500" : ""}`}>
        <div className="selectedImgScroll">
          {isSelectedImage ? (
            <>
              <div className="w-full flex flex-wrap pt-8">
                {selectedImages.map((image, ind) => {
                  return (
                    <div
                      className="w-1/6 2xs:max-base:w-25% relative"
                      key={ind}
                    >
                      <img
                        src={URL.createObjectURL(image)}
                        alt="uploadImage"
                        className="selectedImg"
                        key={ind}
                        onClick={() => handleOpen(URL.createObjectURL(image))}
                      />
                      <X
                        color="#021472"
                        size={20}
                        className="removeSelectedImg"
                        onClick={() => removeSelectedImage(ind)}
                      />
                    </div>
                  );
                })}
              </div>
              <p className="selectedImgLen">{`Total ${selectedImages.length} Images`}</p>
            </>
          ) : (
            <p className="absolute-center-align max-lg:text-xs text-center">
              No Image selected
            </p>
          )}
        </div>
      </div>
      {clickedImage !== null && (
        <ImageDialog
          image={clickedImage}
          closeDialog={() => setClickedImage(null)}
        />
      )}
    </>
  );
};
export default SelectedImagesBox;
